export * from './boolean';
export * from './gender';
export * from './language';
export * from './marital';
export * from './exclusiveOffers';
export * from './relationship';

export function moveOptionToFirstInList(options, value) {
  const optionIndex = (options || []).map((option) => option.value).indexOf(value);
  const newOptions = (options || []).slice();
  if (optionIndex !== -1) {
    const option = newOptions.splice(optionIndex, 1)[0];
    newOptions.unshift(option);
  }
  return newOptions;
}

export function getOptionLabelByValue(options, value) {
  if (!options || !value) return '';
  return (options || []).filter((option) => option.value === value).map((option) => option.label)[0];
}

export function getValueByOptionLabel(options, label) {
  if (!options || !label) return '';
  return (options || []).filter((option) => option.label === label).map((option) => option.value)[0];
}
